import { AlertUtil } from './utils/alert-util';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// APP
import { FilieraComponent } from './filiera/filiera.component';
import { DataTableComponent } from './data-table/data-table.component'
import { HomeComponent } from './home/home.component';
import { AggiudicatariComponent } from './aggiudicatari/aggiudicatari.component';
import { ScadenzarioComponent } from './scadenzario/scadenzario.component';
import { AccessiComponent } from './accessi/accessi.component';
import { CommessaModalComponent } from './commessa-modal/commessa-modal.component';
import { RichiestaModalComponent } from './richiesta-modal/richiesta-modal.component';
import { DocumentoModalComponent } from './documento-modal/documento-modal.component';
import { FilieraModalComponent } from './filiera-modal/filiera-modal.component';
import { AggiudicatarioModalComponent } from './aggiudicatario-modal/aggiudicatario-modal.component';
import { AccessiModalComponent } from './accessi-modal/accessi-modal.component';
import { LoginComponent } from './login/login.component';
import { AppHomeComponent } from './app-home/app-home.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { FullTextSerchComponent } from './full-text-serch/full-text-serch.component';
import { DocumentoPrefettoModalComponent } from './documento-prefetto-modal/documento-prefetto-modal.component';
import { SendRichiestaModalComponent } from './send-richiesta-modal/send-richiesta-modal.component';
import { WbsComponent } from './wbs/wbs.component';
import { ChartModalComponent } from './chart-modal/chart-modal.component';
import { SalComponent } from './sal/sal.component';
import { PaymentModalComponent } from './payment-modal/payment-modal.component';
import { NewSalModalComponent } from './new-sal-modal/new-sal-modal.component';
import { PaymentForCommessaModalComponent } from './payment-for-commessa-modal/payment-for-commessa-modal.component';
import { SalForCommessaModalComponent } from './sal-for-commessa-modal/sal-for-commessa-modal.component';
import { VariazioneAccessiModalComponent } from './variazione-accessi-modal/variazione-accessi-modal.component';
import { ChooseDataModalComponent } from './choose-data-modal/choose-data-modal.component';
import { CommessaSalPaymentModalComponent } from './commessa-sal-payment-modal/commessa-sal-payment-modal.component';
import { EsecutorePagamentiModalComponent } from './esecutore-pagamenti-modal/esecutore-pagamenti-modal.component';
import { AttivitaSalPaymentModalComponent } from './attivita-sal-payment-modal/attivita-sal-payment-modal.component';
import { VariazioneComponent } from './variazione/variazione.component';
import { SendDocumentoModalComponent } from './send-documento-modal/send-documento-modal.component';
import { ChoiseDocVersionModalComponent } from './choise-doc-version-modal/choise-doc-version-modal.component';
import { EsecutoreModalComponent } from './esecutore-modal/esecutore-modal.component';
import { AlertComponent } from './alert/alert.component';
import { GruppoComponent } from './gruppo/gruppo.component';
import { GruppoModalComponent } from './gruppo-modal/gruppo-modal.component';
import { UtenteComponent } from './utente/utente.component';
import { UtenteModalComponent } from './utente-modal/utente-modal.component';
import { AssociaCommessaAGruppoModalComponent } from './associa-commessa-agruppo-modal/associa-commessa-agruppo-modal.component';
import { LogAttivitaComponent } from './log-attivita/log-attivita.component';
import { GestioneAllegatiComponent } from './gestione-allegati/gestione-allegati.component';
import { GestioneAllegatiModalComponent } from './gestione-allegati-modal/gestione-allegati-modal.component';
import { PrivacyModalComponent } from './privacy-modal/privacy-modal.component';
import { EsecutoriComponent } from './esecutori/esecutori.component';
import { MezziComponent } from './mezzi/mezzi.component';
import { MezzoModalComponent } from './mezzo-modal/mezzo-modal.component';
import { PersoneComponent } from './persone/persone.component';
import { PersonaModalComponent } from './persona-modal/persona-modal.component';
import { UploadComponent } from './upload-page/upload.component';

// SERVICE
import { CommessaService } from './services/commessa.service';
import { AccessiService } from './services/accessi.service';
import { DocumentiService } from './services/documenti.service';
import { AggiudicatarioService } from './services/aggiudicatario.service';
import { ScadenzarioService } from './services/scadenzario.service';
import { FilieraService } from './services/filiera.service';
import { RichiestaService } from './services/richiesta.service';
import { LoginService } from './services/login.service';
import { StoricoModuloService } from './services/storicomodulo.service';
import { WbsService } from './services/wbs.service';
import { EsecutoreService } from './services/esecutore.service';
import { AttivitaService } from './services/attivita.service';
import { PaymentService } from './services/payment.service';
import { CantiereService } from './services/cantiere.service';
import { AziendaService } from './services/azienda.service';
import { MezziService } from './services/mezzi.service';
import { PersoneService } from './services/persone.service';
import { UtenteService } from './services/utente.service';
import { GruppoService } from './services/gruppo.service';
import { RuoloService } from './services/ruolo.service';
import { GestioneAllegatiService } from './services/gestione-allegati.service';
import { LogAttivitaService } from './services/logattivita.service';
import { CaricamentiMassiviService } from './services/caricamenti-massivi.service';


//PRIME
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { PaginatorModule } from 'primeng/paginator';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DynamicDialogModule } from 'primeng/components/dynamicdialog/dynamicdialog';
import { DialogService } from 'primeng/api';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ButtonModule } from 'primeng/button';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { CardModule } from 'primeng/card';
import { MenubarModule } from 'primeng/menubar';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { FileUploadModule } from 'primeng/fileupload';
import { TooltipModule } from 'primeng/tooltip';
import { SplitButtonModule } from 'primeng/splitbutton';
import { MenuModule } from 'primeng/menu';
import { DropdownModule } from 'primeng/dropdown';
import { TreeModule } from 'primeng/tree';
import { ChartModule } from 'primeng/chart';
import { ListboxModule } from 'primeng/listbox';
import { ProgressBarModule } from 'primeng/progressbar';
import { MultiSelectModule } from 'primeng/multiselect';
import { DragDropModule } from 'primeng/dragdrop';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ReferentiComponent } from './referenti/referenti.component';
import { NoteModalComponent } from './note-modal/note-modal.component';
import { CommessaListModalComponent } from './commessa-list-modal/commessa-list-modal/commessa-list-modal.component';



// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, "assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    FilieraComponent,
    DataTableComponent,
    HomeComponent,
    AggiudicatariComponent,
    ScadenzarioComponent,
    AccessiComponent,
    FilieraModalComponent,
    CommessaModalComponent,
    RichiestaModalComponent,
    DocumentoModalComponent,
    AggiudicatarioModalComponent,
    AccessiModalComponent,
    LoginComponent,
    AppHomeComponent,
    ChangePasswordComponent,
    FullTextSerchComponent,
    SendRichiestaModalComponent,
    DocumentoPrefettoModalComponent,
    WbsComponent,
    ChartModalComponent,
    SalComponent,
    PaymentModalComponent,
    NewSalModalComponent,
    PaymentForCommessaModalComponent,
    SalForCommessaModalComponent,
    VariazioneAccessiModalComponent,
    ChooseDataModalComponent,
    CommessaSalPaymentModalComponent,
    EsecutorePagamentiModalComponent,
    AttivitaSalPaymentModalComponent,
    VariazioneComponent,
    SendDocumentoModalComponent,
    ChoiseDocVersionModalComponent,
    AlertComponent,
    EsecutoreModalComponent,
    GruppoComponent,
    GruppoModalComponent,
    UtenteComponent,
    UtenteModalComponent,
    AssociaCommessaAGruppoModalComponent,
    LogAttivitaComponent,
    GestioneAllegatiComponent,
    GestioneAllegatiModalComponent,
    PrivacyModalComponent,
    EsecutoriComponent,
    MezziComponent,
    MezzoModalComponent,
    PersoneComponent,
    PersonaModalComponent,
    ReferentiComponent,
    NoteModalComponent,
    UploadComponent,
    CommessaListModalComponent
  ],
  entryComponents: [
    FilieraModalComponent,
    CommessaModalComponent,
    AggiudicatarioModalComponent,
    LoginComponent,
    AccessiModalComponent,
    RichiestaModalComponent,
    DocumentoModalComponent,
    SendRichiestaModalComponent,
    DocumentoPrefettoModalComponent,
    ChartModalComponent,
    PaymentModalComponent,
    NewSalModalComponent,
    PaymentForCommessaModalComponent,
    SalForCommessaModalComponent,
    VariazioneAccessiModalComponent,
    ChooseDataModalComponent,
    CommessaSalPaymentModalComponent,
    EsecutorePagamentiModalComponent,
    AttivitaSalPaymentModalComponent,
    SendDocumentoModalComponent,
    ChoiseDocVersionModalComponent,
    EsecutoreModalComponent,
    GruppoModalComponent,
    UtenteModalComponent,
    AssociaCommessaAGruppoModalComponent,
    GestioneAllegatiModalComponent,
    PrivacyModalComponent,
    MezzoModalComponent,
    PersonaModalComponent,
    NoteModalComponent,
    CommessaListModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    OrganizationChartModule,
    BrowserAnimationsModule,
    TableModule,
    TabMenuModule,
    PaginatorModule,
    DynamicDialogModule,
    DialogModule,
    TabViewModule,
    ButtonModule,
    CalendarModule,
    ScrollPanelModule,
    KeyFilterModule,
    InputTextModule,
    RadioButtonModule,
    OverlayPanelModule,
    InputTextareaModule,
    ConfirmDialogModule,
    CardModule,
    MenubarModule,
    SelectButtonModule,
    CheckboxModule,
    FileUploadModule,
    TooltipModule,
    SplitButtonModule,
    MenuModule,
    DropdownModule,
    TreeModule,
    ChartModule,
    ListboxModule,
    ProgressBarModule,
    MultiSelectModule,
    DragDropModule,
    AutoCompleteModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    EsecutoreService,
    CommessaService,
    DialogService,
    AccessiService,
    DocumentiService,
    AggiudicatarioService,
    ScadenzarioService,
    FilieraService,
    RichiestaService,
    ConfirmationService,
    LoginService,
    StoricoModuloService,
    WbsService,
    AttivitaService,
    PaymentService,
    CantiereService,
    AziendaService,
    MezziService,
    PersoneService,
    AlertUtil,
    GruppoService,
    UtenteService,
    RuoloService,
    GestioneAllegatiService,
    LogAttivitaService,
    CaricamentiMassiviService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
